import { ArrowDownTrayIcon, ArrowLeftOnRectangleIcon } from '@heroicons/react/24/outline';
import { PulseLoader } from 'react-spinners';
import { connect } from 'react-redux';
import RestrictedSignInForm from './RestrictedSignInForm';
import { logout } from '../../actions';
import { FormattedMessage } from 'react-intl';
import { withBase } from '../../utils/pathHelpers';

const LegacyMetedContainer = (props) => {
    const { user, viewer, dispatch } = props;
    const {logged_in, firstName, lastName} = user.metadata;
    const {locale} = viewer.language;

    

    const handleLogout = () => {
        dispatch(logout());
    }

    return (
      <section id="legacy-meted-container" className="p-4">
      
          <>
            {logged_in ? (
              <div className="text-center">
                <h1 className="text-2xl font-bold mb-4 my-12">
                  <FormattedMessage
                    id="meted.welcome_back"
                    defaultMessage="Welcome back, {firstName} {lastName}!"
                    values={{ firstName, lastName }}
                  />
                </h1>
                <p className="text-gray-700 mb-4">
                    <FormattedMessage
                        id="meted.download_docs"
                        defaultMessage="Use the links below to download your records."
                    />
                </p>

                <div className="text-gray-700 my-12 p-4 flex justify-center items-center gap-4 flex-wrap">
                  
                  <a className="border rounded-lg bg-[#1a658f] text-white text-center py-2 shadow-md hover:-translate-y-1 transition-all duration-100 p-4"
                    href={locale === "es_ES" ? withBase("/legacy/getTranscripts_es.php") : withBase("/legacy/getTranscripts.php")}
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                      <div className="p-2">
                        <h1 className="text-lg font-bold">
                            <FormattedMessage
                                id="meted.download_transcript"
                                defaultMessage="Download Transcript"
                            />
                        </h1>
                        <div className="flex justify-center">
                          <ArrowDownTrayIcon className="h-8 w-8 text-white" />
                        </div>
                      </div>
                  </a>

                  <a className="border rounded-lg bg-[#1a658f] text-white text-center py-2 shadow-md hover:-translate-y-1 transition-all duration-100 p-4"
                        href={locale === "es_ES" ? withBase("/legacy/diplomaAll.php?language=6") : withBase("/legacy/diplomaAll.php")}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                      <div className="p-2">
                        <h1 className="text-lg font-bold">
                            <FormattedMessage
                                id="meted.download_certificates"
                                defaultMessage="Download Certificates"
                            />
                        </h1>
                        <div className="flex justify-center">
                          <ArrowDownTrayIcon className="h-8 w-8 text-white" />
                        </div>
                      </div>
                  </a>

                  <a className="border rounded-lg bg-[#1a658f] text-white text-center py-2 shadow-md hover:-translate-y-1 transition-all duration-100 p-4"
                       href={locale === "es_ES" ? withBase("/legacy/getMyQueue.php?language=6") : withBase("/legacy/getMyQueue.php")}
                       target="_blank"
                       rel="noopener noreferrer"
                    >
                      <div className="p-2">
                        <h1 className="text-lg font-bold">
                            <FormattedMessage
                                id="meted.download_my_queue"
                                defaultMessage="Download My Queue"
                            />
                        </h1>
                        <div className="flex justify-center">
                          <ArrowDownTrayIcon className="h-8 w-8 text-white" />
                        </div>
                      </div>
                  </a>
                </div>

                {/* logout button */}
                <button
                  className="text-white bg-gray-500 hover:bg-gray-700 font-bold my-2 py-4 px-12 rounded inline-block mx-2 shadow-md hover:-translate-y-1 transition-all duration-100 p-4"
                  onClick={handleLogout}
                >
                  
                  <ArrowLeftOnRectangleIcon className="w-6 h-6 inline-block mr-2" />
                  <FormattedMessage
                    id="userMenu.logout"
                    defaultMessage="Logout"
                  />
                </button>
                <br /><br />
                <a href={withBase("/legacy/passwordForm.php")}
                  className='font-medium text-blue-600 hover:text-blue-500 hover:underline'
                >
                  <FormattedMessage
                    id="meted.legacy_content_blurb"
                    defaultMessage="Change your password"
                  />
                </a>

              </div>
            ) : (
              <div className="text-center">
                <h1 className="text-2xl font-bold mb-4 text-gray-700">
                  <FormattedMessage
                    id="meted.my_meted_records"
                    defaultMessage="My MetEd Records"
                  />
                </h1>
                <p className="text-gray-700">
                  <FormattedMessage
                    id="meted.legacy_content_blurb"
                    defaultMessage="Please use your legacy MetEd account to log in and download your records."
                  />
                </p>
                <p className="text-gray-700 mb-4">
                  <FormattedMessage
                    id="meted.legacy_content_issues"
                    defaultMessage="If you have any issues accessing your legacy records, please reach out to: support@comet.ucar.edu."
                  />
                </p>
                <RestrictedSignInForm />
              </div>
            )}
          </>
        
        <div className='my-48 spacer' />
      </section>
    );
};

function mapStateToProps({ user, viewer, dispatch }) {
	return { user, viewer, dispatch };
}

export default connect(mapStateToProps)(LegacyMetedContainer);